<template>
  <blockquote
    class="skeleton"
    style="width: 100%; margin-bottom: 40px; float: left; background: #f8f8f8"
  >
    <div style="width: 100%; height: 30px">
      <div class="skeleton-circle-md" />
      <div class="max-width-md skeleton-part-sm skeleton-width-lg" />
    </div>

    <div style="width: 100%; height: 30px">
      <div class="skeleton-circle-md" />
      <div class="max-width-md skeleton-part-sm" />
    </div>

    <div style="width: 100%; height: 30px">
      <div class="skeleton-circle-md" />
      <div class="max-width-md skeleton-part-sm skeleton-width-sm" />
    </div>

    <div style="width: 100%; height: 30px">
      <div class="skeleton-circle-md" />
      <div class="max-width-md skeleton-part-sm" />
    </div>

    <div style="width: 100%; height: 30px">
      <div class="skeleton-circle-md" />
      <div class="max-width-md skeleton-part-sm skeleton-width-sm" />
    </div>
  </blockquote>
</template>
